import { defineTenant } from './theme/config'
export default defineTenant({
  brand: {
    name: 'Bank Rakyat',
    logo: {
      light:
        'https://cdn.magicpatterns.com/uploads/hUH4DDXHc5y9TQTbLyJVf2/Bank_Rakyat_English_Wiki.png',
      dark: 'https://cdn.magicpatterns.com/uploads/hUH4DDXHc5y9TQTbLyJVf2/Bank_Rakyat_English_Wiki.png',
    },
    favicon:
      'https://cdn.magicpatterns.com/uploads/hUH4DDXHc5y9TQTbLyJVf2/Bank_Rakyat_English_Wiki.png',
  },
  locale: {
    default: 'en-US',
    supported: ['en-US'],
    timezone: 'Asia/Kuala_Lumpur',
  },
  currency: {
    code: 'MYR',
  },
})
